export const referentVariables = [
  { label: "Référent", value: "candidate.authors" },
  { label: "Téléphone référent", value: "candidate.authorsPhone" },
  { label: "Poste référent", value: "candidate.authorsPosition" },
  { label: "Email du référent", value: "candidate.authorsEmail" },
  { label: "Responsable du référent", value: "candidate.authorsManager" },
];
